import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../store/sagas";
import {apiPost} from "./client";

export const useReport = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (targetId, isPost, reason, customReason) {
        yield call(apiPost, `/api/v2/action/report`, {
            target: targetId,
            post: isPost,
            reason,
            customReason,
        });
    }, []));
}
